/*
 * Copyright (C) 2022-2023 Indoc Systems
 *
 * Contact Indoc Systems for any questions regarding the use of this source code.
 */
import('./bootstrap.js');
